import createIcon from '@/lib/create-icon'

const BasketballIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 46 46' fill='none'>
    <path
      d='M5.92045 20.5595C11.1085 19.8222 16.5678 21.4489 20.5585 25.4395C24.5491 29.4301 26.1757 34.8895 25.4384 40.0775M40.0755 25.4404C34.8875 26.1777 29.4281 24.551 25.4375 20.5604C21.4469 16.5698 19.8202 11.1104 20.5576 5.92242M35.1947 10.8025L10.7995 35.1977M10.8024 35.1976C17.539 41.9341 28.461 41.9341 35.1976 35.1976C41.9341 28.461 41.9341 17.539 35.1976 10.8024C28.461 4.06586 17.539 4.06586 10.8024 10.8024C4.06586 17.539 4.06586 28.461 10.8024 35.1976Z'
      stroke='url(#linear-gradient-svg-sports)'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M5.92045 20.5595C11.1085 19.8222 16.5678 21.4489 20.5585 25.4395C24.5491 29.4301 26.1757 34.8895 25.4384 40.0775M40.0755 25.4404C34.8875 26.1777 29.4281 24.551 25.4375 20.5604C21.4469 16.5698 19.8202 11.1104 20.5576 5.92242M35.1947 10.8025L10.7995 35.1977M10.8024 35.1976C17.539 41.9341 28.461 41.9341 35.1976 35.1976C41.9341 28.461 41.9341 17.539 35.1976 10.8024C28.461 4.06586 17.539 4.06586 10.8024 10.8024C4.06586 17.539 4.06586 28.461 10.8024 35.1976Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M5.92045 20.5595C11.1085 19.8222 16.5678 21.4489 20.5585 25.4395C24.5491 29.4301 26.1757 34.8895 25.4384 40.0775M40.0755 25.4404C34.8875 26.1777 29.4281 24.551 25.4375 20.5604C21.4469 16.5698 19.8202 11.1104 20.5576 5.92242M35.1947 10.8025L10.7995 35.1977M10.8024 35.1976C17.539 41.9341 28.461 41.9341 35.1976 35.1976C41.9341 28.461 41.9341 17.539 35.1976 10.8024C28.461 4.06586 17.539 4.06586 10.8024 10.8024C4.06586 17.539 4.06586 28.461 10.8024 35.1976Z'
      stroke='url(#radial-gradient-svg-sports)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />

    <defs>
      <linearGradient
        id='linear-gradient-svg-sports'
        x1='5.75'
        y1='5.75'
        x2='45.1888'
        y2='33.1381'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>

      <radialGradient
        id='radial-gradient-svg-sports'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 40.25) scale(17.25 17.5687)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'BasketballIcon'
)

export default BasketballIcon
